import React from 'react';
import { View } from 'react-native';
import { ChatExerciseRow } from './ChatExerciseRow';
import { PresentationCaption } from './PresentationCaption';

interface WorkoutExerciseCardProps {
  caption?: string | null;
  workoutExerciseId: string;
}

interface WorkoutExerciseCardSyncedProps {
  payload: Record<string, unknown>;
}

interface WorkoutExercisePayload {
  caption?: string | null;
  workoutExerciseId?: string;
}

/**
 * `present_workout_exercise` (design fgChe) → a single exercise card: name +
 * set-summary subtitle, the editable sets table and note. Expanded, no chevron.
 */
export const WorkoutExerciseCard: React.FC<WorkoutExerciseCardProps> & {
  Synced: React.FC<WorkoutExerciseCardSyncedProps>;
} = ({ caption, workoutExerciseId }) => (
  <View className="w-full py-2 gap-2">
    <PresentationCaption caption={caption} />
    <View className="bg-surface rounded-2xl p-4">
      <ChatExerciseRow exerciseId={workoutExerciseId} className="py-0" />
    </View>
  </View>
);

const WorkoutExerciseCardSynced: React.FC<WorkoutExerciseCardSyncedProps> = ({
  payload,
}) => {
  const { caption, workoutExerciseId } = payload as WorkoutExercisePayload;

  if (!workoutExerciseId) {
    return null;
  }

  return (
    <WorkoutExerciseCard
      caption={caption}
      workoutExerciseId={workoutExerciseId}
    />
  );
};

WorkoutExerciseCard.Synced = WorkoutExerciseCardSynced;
